/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { RootState } from '../../store';

/** Returns map of sensor id to sensor name */
export const selectSensorIdToName = (state: RootState) => state.sensingSystemArchitectureDesign.sensorIdToName

/** Returns map of greenline id to greenline properties */
export const selectGreenlineIdToProperties = (state: RootState) => state.sensingSystemArchitectureDesign.greenlineIdToProperties

/** Returns the name of a given green line data set */
export const selectGreenLineName = (state: RootState, greenLineId: string) => {
    const greenLineProperties = state.sensingSystemArchitectureDesign.greenlineIdToProperties[greenLineId]
    return greenLineProperties ? greenLineProperties.name : null
}

/** Returns the error of a given green line data set */
export const selectGreenLineError = (state: RootState, greenLineId: string) => {
    const greenLineProperties = state.sensingSystemArchitectureDesign.greenlineIdToProperties[greenLineId]
    return greenLineProperties ? greenLineProperties?.error ?? null : null
}

/** Returns map of greenline id to greenline data */
export const selectGreenlineIdToPlotData = (state: RootState) => state.sensingSystemArchitectureDesign.greenlineIdToPlotData

export const selectGreenlineIdToRunState = (state: RootState) => state.sensingSystemArchitectureDesign.greenlineIdToRunState
export const selectSensorIdToBlueLineRunState = (state: RootState) => state.sensingSystemArchitectureDesign.sensorIdToBlueLineRunState

/** Returns all studies */
export const selectStudies = (state: RootState) => state.sensingSystemArchitectureDesign.studies

/** Returns the current study ID */
export const selectCurrentStudyId = (state: RootState) => state.sensingSystemArchitectureDesign.currentStudyId

/** Returns all study data for the given study ID */
export const selectStudy = (state: RootState, studyId: string) => state.sensingSystemArchitectureDesign.studies.find(study => study.id === studyId)

/** Returns the experiment for the study */
/** TODO: When support for multiple experiments in a study is added, add experimentId as a parameter to select */
export const selectExperiment = (state: RootState) => state.sensingSystemArchitectureDesign.experiments?.[0]

/** Returns the experiment ID for the study */
export const selectExperimentId = (state: RootState) => state.sensingSystemArchitectureDesign.experiments?.[0]?.id


/** Returns the loading state */
export const selectLoadingState = (state: RootState) => state.sensingSystemArchitectureDesign.loading

/** Returns the study form dialog state */
export const selectStudyFormDialog = (state: RootState) => state.sensingSystemArchitectureDesign.dialogs.studyForm

/** Returns the confirm action dialog state */
export const selectConfirmStudyActionDialog = (state: RootState) => state.sensingSystemArchitectureDesign.dialogs.confirmStudyAction

/** Returns the connect ADAS Program wizard state */
export const selectConnectAdasProgramWizard = (state: RootState) => state.sensingSystemArchitectureDesign.wizards.connectAdasProgram

/** Returns the Edit Sensor wizard state */
export const selectEditSensorWizard = (state: RootState) => state.sensingSystemArchitectureDesign.wizards.editSensor

/** Returns the download data set dialog state */
export const selectDownloadDataSetDialog = (state: RootState) => state.sensingSystemArchitectureDesign.dialogs.downloadDataSet

/** Returns the view data set errors dialog state */
export const selectViewDataSetErrorsDialog = (state: RootState) => state.sensingSystemArchitectureDesign.dialogs.viewDataSetErrors


/** Returns the table state */
export const selectTable = (state: RootState) => state.sensingSystemArchitectureDesign.table


/** Returns the loading state */
export const selectLoading = (state: RootState) => state.sensingSystemArchitectureDesign.loading
